import React from 'react';
import {BlobProvider} from "@react-pdf/renderer/dist/react-pdf.es";
import i18n from "../../../i18n";
import {replaceVowels} from "../../Form/utils";
import moment from "moment";
import {fileType} from "../../Utilities";
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import _ from "lodash";


const formatString = (str) => {
    str = replaceVowels(str);
    return str.replace(/[^a-zA-Z0-9]/g, "_");
}

const setFileNameAndType = (values) => {

    // internal number of construction project
    //let fileName = (values.number_internal || '').replace('/','-');
    let fileName;
    let now = moment().format('YYYYMMDD');

    let typeOfFile = fileType(values);
    let typeName = formatString( i18n.get('deficiency.pdf.' + typeOfFile) );
    fileName = typeName + (now ? '_' + now : '');

    return {type:typeOfFile,name:fileName};
}

const FileRenderer = (props) => {
    const {
        document,
        renderState,
        values,
        onRendered,
    } = props;

    let file = setFileNameAndType(values);
    const fileName = file.name;
    const fileType = file.type;

    return (
        <BlobProvider document={document}>
            {({ blob, url, loading, error }) => {
                if(loading) {
                    window.debug && console.log('is loading');
                }
                if (error) {
                    //return (<p>An error occurred</p>);
                    window.debug && console.debug(error);
                }
                if(!error && !loading && blob && url) {
                    window.debug && console.log('blob loaded', fileName);

                    const config = {headers: {'Content-Type': 'multipart/form-data'}};
                    let fd = new FormData();
                    fd.append('File[]', blob, `${fileName ? fileName : 'unknown'}.pdf`);
                    fd.append('meta[]',JSON.stringify({
                        refType:'project',
                        refId:values.id,
                        fileType:fileType,
                    }));

                    let file = null;
                    for (let value of fd.values()) {
                        if (typeof value === 'object' && value.name){
                            file = value;
                        }
                    }

                    if(file) {
                        axios.post('/f/multiple', fd, config).then(response => {
                            window.debug && console.log('file saved');
                            if (response.data && response.data.file_id ) {
                                try {
                                    file.sHash = response.data.file_id[0] || '';
                                    file.icon = response.data.icons[0] || '';
                                    file.isImage = response.data.pics[0] || '';
                                    file.mcePic = response.data.mcePic[0] || '';
                                    file.sPrevPic = response.data.prevPic[0] || '';
                                    file.sTags = response.data.tags[0] || '';
                                    file.sExt = response.data.ext[0] || '';
                                    file.isNew = true;
                                    file.isDeleted = false;
                                    file.iId = response.data.id[0] || '';
                                    file.id = response.data.id[0] || '';
                                } catch (ex) {
                                    console.error(ex);
                                }
                            }
                            renderState(true);
                            onRendered(file);
                        }).catch(error => {
                            console.error('FileRenderer', error);
                        })
                    }
                    return true;
/*
                    return (
                        <Button download={`${fileName}.pdf`}
                            component={'a'}
                            href={url}
                            size="small"
                            variant="contained"
                            color="primary"
                            type="button"
                            style={{marginRight:10}}
                        >
                            <Icon fontSize="small">description</Icon>
                            &nbsp;
                            {i18n.get('deficiency.save_pdf')}
                        </Button>
                    );*/
                }
                return null;
            }}
        </BlobProvider>
    );
}

export default FileRenderer;
